<template>
  <v-dialog v-model="isShow" persistent max-width="1200">
    <v-card style="height: 90dvh !important">
      <v-layout>
        <v-flex>
          <div class="primary--text headline pa-2">Upload Drive</div>
        </v-flex>
        <v-flex>
          <div class="text-xs-right">
            <v-btn flat fab small @click="handleClose">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <iframe
        sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
        allowfullscreen="true"
        :src="src"
        style="
          height: 93%;
          overflow: auto;
          width: 100%;
          border: none;
          position: absolute;
          inset: 60px 0 0;
        "
      />
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isShow: this.value,
      renderKey: Date.now()
    }
  },
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://cms.enterprise.zwiz.app/${this.currentLang}/drive-upload-iframe?inputType=video&multipleFile=false&timestamp=${this.renderKey}`
    }
  },
  watch: {
    value(isOpen) {
      this.isShow = isOpen
      if (!isOpen) {
        this.renderKey = Date.now()
      }
    }
  },
  mounted() {
    window.addEventListener(
      'message',
      (e) => {
        if (e.data) {
          this.handleListenEventMessage(e.data)
        }
      },
      false
    )
  },
  beforeDestroy() {
    window.removeEventListener(
      'message',
      (e) => {
        if (e.data) {
          this.handleListenEventMessage(e.data)
        }
      },
      false
    )
  },
  methods: {
    handleClose() {
      this.isShow = false
      this.$emit('close')
    },
    handleListenEventMessage({ event_id, data }) {
      switch (event_id) {
        case 'send_file_drive_payload':
          this.handleClose()
          this.$emit('upload', data[0].url)
          console.log(data)
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/Dialog/UploadFileDrive.vue